import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'logout',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./modules/change-password/change-password.module').then(m => m.ChangePasswordPageModule)
  },
  {
    path: 'forget-password',
    loadChildren: () => import('./modules/forget-password/forget-password.module').then(m => m.ForgetPasswordPageModule)
  },
  {
    path: 'experiment-set',
    loadChildren: () => import('./modules/experiment-set/experiment-set.module').then(m => m.ExperimentSetPageModule)
  },
  {
    path: 'calendar',
    loadChildren: () => import('./modules/calendar/calendar.module').then(m => m.CalendarPageModule)
  },
  {
    path: 'signin',
    loadChildren: () => import('./modules/signin/signin.module').then(m => m.SigninPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterPageModule)
  },
  {
    path: 'booking-list',
    loadChildren: () => import('./modules/booking-list/booking-list.module').then(m => m.BookingListPageModule)
  },
  {
    path: 'session',
    loadChildren: () => import('./modules/session/session.module').then(m => m.SessionPageModule)
  },
  {
    path: 'summary',
    loadChildren: () => import('./modules/summary/summary.module').then(m => m.SummaryPageModule)
  },
  {
    path: 'success',
    loadChildren: () => import('./modules/success/success.module').then(m => m.SuccessPageModule)
  },
  {
    path: 'run',
    loadChildren: () => import('./modules/run/run.module').then(m => m.RunPageModule)
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home', pathMatch: 'prefix' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
